import React, { useMemo } from 'react'
import { differenceInDays } from 'date-fns'
import { Badge, Tooltip } from '@maui/elements'

export function NewBadge({ date, color, tooltip }) {
  const isNew = useMemo(() => {
    if (!date) return false
    return differenceInDays(new Date(), new Date(date)) < 30
  }, [date])

  return (
    isNew && (
      <Tooltip
        placement='bottom'
        tooltip={tooltip}
      >
        <Badge
          color={color}
          padding='4px'
          ml='8px'
          borderWidth='1px'
          borderStyle='solid'
          borderColor='colorBorderMain'
          backgroundColor='colorFillDeemphasis'
          display='flex'
          alignItems='center'
          justifyContent='center'
          gap='4x'
          width='38px'
          height='20px'
        >
        NEW
        </Badge>
      </Tooltip>
    )
  )
}
